<template>
    <el-dialog
        :title="'配送单-蓝月亮打印'"
        :width="'500px'"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'bluemoonPrintDialog'"
    >
        <el-radio-group v-model="printUrl" style="width: 100%">
            <el-row :gutter="20">
                <el-col
                    v-for="item in data"
                    :key="item.deliveryCode"
                    :span="12"
                    style="margin-bottom: 20px"
                >
                    <el-radio :label="item.url" border style="width: 100%">{{
                        item.deliveryCode
                    }}</el-radio>
                </el-col>
            </el-row>
        </el-radio-group>
        <template #footer>
            <div>
                <el-button @click="beforeClose">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
export default {
    name: 'bluemoonPrintDialog',
    props: {
        data: {
            type: Array,
            default () { return []; }
        }
    },
    data () {
        return {
            printUrl: ''
        };
    },
    methods: {
        // 确定
        handleSubmit () {
            if (!this.printUrl) {
                return this.$message.warning('未选择单据，不能确定！');
            }
            window.open(this.printUrl);
            this.beforeClose();
            this.$emit('closePrintDialog');
        },

        // 关闭
        beforeClose () {
            this.$emit('update:bluemoonPrintVisible', false);
        }
    }
};
</script>
<style lang="less">
.bluemoonPrintDialog {
    .el-dialog__body {
        padding: 22px 22px 0;
        .el-radio.is-bordered {
            height: 34px;
            padding: 10px 20px 0 10px;
        }
    }
}
</style>
